import { useEffect } from 'react';
import { gamesStoreActions } from '../../../store';

const { PLEX_SET_PAGINATION } = gamesStoreActions;

export const useAdjustPaginationGamesToCurrentPageNumber = ({
  paginationGames = [],
  formattedPage,
  pageSize,
  entity,
  entityId,
  adjustIsEnabled
}) => {
  useEffect(() => {
    if (
      entityId &&
      adjustIsEnabled &&
      paginationGames &&
      paginationGames.length > formattedPage * pageSize
    ) {
      const adjustedGamesIds = paginationGames.slice(
        0,
        formattedPage * pageSize
      );

      PLEX_SET_PAGINATION({
        entity,
        pagination: {
          id: entityId,
          gamesIds: adjustedGamesIds
        }
      });
    }
  }, [paginationGames, formattedPage, pageSize, adjustIsEnabled]);
};
